import React, { useState } from "react";
import FilterComponent from "../Layout/FilterComponent";
import SearchExportComponent from "../Layout/SearchExportComponent";
import TableLayout from "../Layout/TableLayout";
import Pagination from "../Layout/Pagination";
import DetailBox from "./DetailBox";
import SearchExportFilterComponent from "../Layout/SearchExportFilterComponent";
import { COMPANIES, DOCTORS } from "../../constants/fetchData";
import { getDistributorNames, getExportData } from "../../Common/functions";

const ApplicationOverview = ({
  data,
  loading,
  currentPage,
  totalPages,
  totalCount,
  setCurrentPage,
  userRole,
  setSearchTerm,
  setFilters,
  itemsPerPage,
  setItemsPerPage,
}) => {
  const [openDetailBox, setOpenDetailBox] = useState(false);
  const [selectedObject, setSelectedObject] = useState([]);
  const [visibleHeaders, setVisibleHeaders] = useState([
    "dates",
    "username",
    "doctorsname",
    "distributor_name",
    "patientname",
    "quantity",
    "action",
  ]);
  const tableHeaders = [
    { label: "Date", value: "dates" },
    { label: "Distributor", value: "distributor_name" },
    { label: "UserName", value: "username" },
    { label: "Doctor", value: "doctorsname" },
    { label: "Product Group", value: "product_group" },
    { label: "Patient Name", value: "patientname" },
    { label: "Quantity", value: "quantity" },
    { label: "Value", value: "unit_price" },
    { label: "Status", value: "tracking_status" },
    { label: "Action", value: "action" },
  ];
  const filterFields = [
    {
      type: "dropdown",
      label: "Distributor name",
      id: "distributorName",
      options:
        userRole === "super_admin"
          ? COMPANIES
          : getDistributorNames().map((item) => ({ value: item, label: item })),
    },
    {
      type: "dropdown",
      label: "Tracking status",
      id: "trackingStatus",
      options: [
        { value: "Demo", label: "Demo" },
        { value: "Lead", label: "Lead" },
        { value: "Sale", label: "Sale" },
        { value: "NoSale", label: "No Sale" },
      ],
    },
    {
      type: "dropdown",
      label: "Doctor name",
      id: "doctorName",
      options: DOCTORS,
    },
    {
      type: "dropdown",
      label: "Choose team",
      id: "chooseTeam",
      options: [
        { value: "Avana_Employee", label: "Internal User" },
        { value: "Distributor", label: "Distributor" },
        { value: "Distributor_Admin", label: "Distributor Admin" },
      ],
    },
    {
      type: "dropdown",
      label: "Product group",
      id: "productGroup",
      options: [
        // { value: "group1", label: "Group 1" },
        // { value: "group2", label: "Group 2" },
      ],
    },

    { type: "date", label: "From Date", id: "fromDate" },
    { type: "date", label: "To Date", id: "toDate" },
  ];
  const handleApplyFilters = (filters) => {
    // console.log("Filters applied:", filters);
    setFilters(filters);
  };

  const handleResetFilters = () => setFilters({});
  const handleSearch = (term) => setSearchTerm(term);
  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
  };
  const handlePageChange = (page) => setCurrentPage(page);
  const handleExport = () => console.log("Exporting data:", data);

  const handleViewAction = (item) => {
    console.log("view");
    console.log("item", item);
    setSelectedObject(item);
    setOpenDetailBox(true);
  };

  const exportData = getExportData(data, tableHeaders, visibleHeaders);

  return (
    <div className="px-0 sm:px-4 ">
      {userRole === "super_admin" || userRole === "manager" ? (
        <>
          <div className="hidden sm:block">
            <FilterComponent
              fields={filterFields}
              onApply={handleApplyFilters}
              onReset={handleResetFilters}
            />
          </div>
          <SearchExportComponent
            exportFileName="ApplicationReport"
            onSearch={handleSearch}
            onExport={handleExport}
            // searchPlaceholder="Search"
            tablefields={tableHeaders}
            selectedHeaders={visibleHeaders}
            onHeadersChange={setVisibleHeaders}
            fields={filterFields}
            onApply={handleApplyFilters}
            onReset={handleResetFilters}
            exportData={exportData} //FIXME:
            // ExportOptionVisisbility={userRole !== "manager"}
          />
        </>
      ) : (
        <div className="pt-2">
          <SearchExportFilterComponent
            exportFileName="ApplicationReport"
            onSearch={handleSearch}
            onExport={handleExport}
            // searchPlaceholder="Search"
            tablefields={tableHeaders}
            selectedHeaders={visibleHeaders}
            onHeadersChange={setVisibleHeaders}
            fields={filterFields}
            onApply={handleApplyFilters}
            onReset={handleResetFilters}
            exportData={exportData} //FIXME:
            // ExportOptionVisisbility={userRole !== "manager"}
          />
        </div>
      )}
      <TableLayout
        data={data}
        loading={loading}
        headers={tableHeaders.filter((header) =>
          visibleHeaders.includes(header.value)
        )}
        handleAction={handleViewAction}
      />

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        onPageChange={handlePageChange}
        itemsPerPage={itemsPerPage}
        onItemsPerPageChange={handleItemsPerPageChange}
      />
      {openDetailBox && (
        <DetailBox
          handleClose={() => setOpenDetailBox(false)}
          selectedObject={selectedObject}
          editIconVisibility={
            userRole !== "super_admin" && userRole !== "manager"
          }
        />
      )}
    </div>
  );
};

export default ApplicationOverview;
